/** Pixen Intrigue — English overrides for the commerce feature. Courtly-fae voice. */
export const commercePixEn = {
  // DtrpgClaimPage.tsx
  'commerce.dtrpg.seoDescription': 'Import your DriveThruRPG library and claim your Pixen Intrigue PDFs.',
  'commerce.dtrpg.intro':
    'Bought Pixen Intrigue on DriveThruRPG or backed the campaign? Sign in with your purchase email to import your library and claim your copies.',
  'commerce.dtrpg.checkInboxSuffix':
    'If that email backed or bought Pixen Intrigue, a sign-in link is on its way — click it to return here and claim your library.',
  'commerce.dtrpg.libraryHeading': 'Your Pixen Intrigue library',

  // PaywallPrompt.tsx
  'commerce.paywall.vaultSealed': 'The Court ledger is sealed for now — please try again soon.',
  'commerce.paywall.openingVault': 'Opening the ledger…',

  // MarketplacePage.tsx
  'commerce.marketplace.loading': 'Gathering your favors…',

  // SubscriberPerksPage.tsx
  'commerce.subscriber.intro':
    'Support the hosts and creators you love — and unlock the perks they reserve for their inner circle.',
  'commerce.subscriber.activeBlurb': 'Your perks are active. Look for the subscriber crest on tables you can join.',
  'commerce.subscriber.paywallTitle': 'Pixen Intrigue Subscriber',
  'commerce.subscriber.paywallBlurb': 'Unlock subscriber-only tables, early content, and your subscriber crest.',

  // TicketCheckoutPage.tsx
  'commerce.ticket.notFoundBlurb': 'This table may have closed its doors, or its salon was never opened.',
  'commerce.ticket.freeBlurb': 'No ticket required — pull up a chair.',

  // TipGoalManagerPage.tsx
  'commerce.tip.goalLabelPlaceholder': "Goal label (e.g. Win the Queen's favor)",
  'commerce.tip.bountyLabelPlaceholder': 'Bounty label (e.g. Nat 20 seals the deal)',
  'commerce.tip.loading': 'Reading the ledger…',
  'commerce.tip.loadErrorTitle': 'Could not load the ledger',
}
